import { AxiosResponse } from "axios";
import { api } from "./base/api";
import { KeyValue } from "../models/common";
import { Result } from "../models/common/resultResponse";
import { IRequestFormatApi } from "./base/requestFormatApi";
import { RequestFormatRequest } from "../models/request/RequestFormatRequest";

const baseRoute: string = "RequestFormat";

export class RequestFormatApi extends IRequestFormatApi {
	getDomain(request: RequestFormatRequest): Promise<AxiosResponse<Result<KeyValue[]>>> {
		return api.get(`${baseRoute}/domain`, { params: request });
	}
}
